<template>
    <div>
        <h2 class="mb-5" style="color: #0b697e">Texte d'introduction</h2>
        <ckeditor
          :editor="editor"
          :value="txtIntro"
          disabled
        ></ckeditor>

        <h2 class="mb-5 mt-5" style="color: #0b697e">Champs du formulaire</h2>
        <div class="tabulation-title d-flex justify-content-between">
            <h3>
                Champs communs
            </h3>
        </div>

        <div class="d-flex justify-content-between flex-wrap gap-20 p-1 mb-10">
            <v-card v-for="tabulation in nonTypeDepenant" :key="tabulation.id" class="info-card">
                <v-app-bar dark class="bg-primary">
                    <v-checkbox class="mt-auto mb-auto" style="padding-top: 0!important;" disabled
                                v-model="checkedTabulations[tabulation.id]"
                                hide-details>
                    </v-checkbox>

                    <v-toolbar-title>
              <span v-if="tabulation.new_title !== undefined && tabulation.new_title !== null &&
              tabulation.new_title !== ''">
                  {{ tabulation.new_title }}
              </span>
                        <span v-else>
              {{ tabulation.label }}
          </span>
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                </v-app-bar>

                <v-card-text>
                    <v-treeview selectable activatable selected-color="primary" item-key="_id"
                                :value="selectedFields[tabulation.id]"
                                return-object :open-on-click="true" :items="tabulation.children">

                        <template v-slot:label="{ item }">
                            <div class="d-flex justify-content-start">
                                <div
                                  v-if="item.new_title !== undefined && item.new_title !== null && item.new_title !== ''">
                                    <v-tooltip slot="append-outer" bottom open-delay="700">
                                        <template v-slot:activator="{ on }">
                                            <span v-on="on">{{ item.new_title }}</span>
                                        </template>
                                        <span>
                                            {{ item.new_title }}
                                            <span v-if="isAspectField(item)" class="ml-2">{{ aspectIcone }}</span>
                                        </span>
                                    </v-tooltip>
                                </div>
                                <div v-else>
                                    <v-tooltip slot="append-outer" bottom open-delay="700">
                                        <template v-slot:activator="{ on }">
                                            <span v-on="on">{{ item.name }}</span>
                                        </template>
                                        <span>
                                            {{ item.name }}
                                            <span v-if="isAspectField(item)" class="ml-2">{{ aspectIcone }}</span>
                                        </span>
                                    </v-tooltip>
                                </div>

                                <div v-if="isAspectField(item)" class="ml-2">
                                    <v-tooltip slot="append-outer" bottom open-delay="700">
                                        <template v-slot:activator="{ on }">
                                            <span v-on="on">{{ aspectIcone }}</span>
                                        </template>
                                        <span>Ce champ concerne l'aspect</span>
                                    </v-tooltip>
                                </div>
                            </div>
                        </template>

                        <template v-slot:append="{ item }">
                            <v-btn color="red" icon
                                   v-if="(item.children === undefined || !item.children.length)  && hasFieldRequiredEnabled(item)">
                                <v-icon v-if="item.required">star</v-icon>
                                <v-icon v-else>star_border</v-icon>
                            </v-btn>
                        </template>

                    </v-treeview>
                </v-card-text>
            </v-card>
        </div>

        <div class="tabulation-title d-flex justify-content-between">
            <h3>
                Champs dépendants des catégories
            </h3>
        </div>

        <div class="d-flex justify-content-between flex-wrap p-1 gap-20">
            <v-card v-for="tabulation in typeDependant"
                    :key="tabulation.id"
                    v-if="isTabulationEnabled(tabulation)"
                    class="info-card">
                <v-app-bar dark class="bg-primary">
                    <v-checkbox class="mt-auto mb-auto" style="padding-top: 0!important;" disabled
                                v-model="checkedTabulations[tabulation.id]"
                                hide-details>
                    </v-checkbox>

                    <v-toolbar-title>{{ tabulation.label }}</v-toolbar-title>
                    <v-spacer></v-spacer>
                </v-app-bar>

                <v-card-text>
                    <v-treeview selectable selected-color="primary" item-key="_id" rounded
                                :value="selectedFields[tabulation.id]"
                                return-object :open-on-click="true" :items="tabulation.children">

                        <template v-slot:label="{ item }">
                            <div class="d-flex justify-content-start">
                                <div
                                  v-if="item.new_title !== undefined && item.new_title !== null && item.new_title !== ''">
                                    <v-tooltip slot="append-outer" bottom open-delay="700">
                                        <template v-slot:activator="{ on }">
                                            <span v-on="on">{{ item.new_title }}</span>
                                        </template>
                                        <span>
                                            {{ item.new_title }}
                                            <span v-if="isAspectField(item)" class="ml-2">{{ aspectIcone }}</span>
                                        </span>
                                    </v-tooltip>
                                </div>
                                <div v-else>
                                    <v-tooltip slot="append-outer" bottom open-delay="700">
                                        <template v-slot:activator="{ on }">
                                            <span v-on="on">{{ item.name }}</span>
                                        </template>
                                        <span>
                                            {{ item.name }}
                                            <span v-if="isAspectField(item)" class="ml-2">{{ aspectIcone }}</span>
                                        </span>
                                    </v-tooltip>
                                </div>

                                <div v-if="isAspectField(item)" class="ml-2">
                                    <v-tooltip slot="append-outer" bottom open-delay="700">
                                        <template v-slot:activator="{ on }">
                                            <span v-on="on">{{ aspectIcone }}</span>
                                        </template>
                                        <span>Ce champ concerne l'aspect</span>
                                    </v-tooltip>
                                </div>
                            </div>
                        </template>

                        <template v-slot:append="{ item }">
                            <v-tooltip slot="append-outer" bottom
                                       v-if="(item.children === undefined || !item.children.length)">
                                <template v-slot:activator="{ on }">
                                    <v-btn v-on="on" color="red" icon>
                                        <v-icon v-if="item.required">star</v-icon>
                                        <v-icon v-else>star_border</v-icon>
                                    </v-btn>
                                </template>
                                <span>Rendre le champ obligatoire</span>
                            </v-tooltip>
                        </template>
                    </v-treeview>
                </v-card-text>
            </v-card>
        </div>

        <div class="text-right mb-5 mt-5" v-if="hideNextButton === undefined || !hideNextButton">
            <v-btn class="default-button" @click="setCurrentStep(parseInt(currentStep) + 1)">Passer à l'étape
                suivante
            </v-btn>
        </div>
    </div>
</template>

<script>
import { mapMutations, mapState } from "vuex"
import _ from "lodash"
import ClassicEditor from "../../../../plugins/ckeditor"
import { aspectElements, aspectFields } from "../../../../static/webform"

export default {
    name: "InformationReadOnly",
    props: ["tabulations", "selectAll", "hideNextButton", "categories", "aspect"],
    data() {
        return {
            typeDependant: [],
            nonTypeDepenant: [],
            checkedTabulations: {},
            selectedCategory: null,
            currentField: null,
            fieldModal: false,
            newTitle: null,
            helpDescription: null,
            disabledEditField: [
                "GOOGLE", "FACEBOOK", "TWITTER", "TRIPADVISOR", "YELP", "YOUTUBE", "INSTAGRAM",
                "COMPLEMENT_OUVERTURE", "ALWAYS_OPEN", "OPEN_24", "NAME",
                "ROOM_DESCRIPTION_COURT", "ROOM_DESCRIPTION", "MAX_CAPACITY_PERS", "AREA", "ROOM_HEIGHT",
                "NATURAL_LIGHT", "ROOM_U", "ROOM_BANQUET", "ROOM_SQUARE", "ROOM_CLASS", "ROOM_COCKTAIL", "ROOM_THEATRE",
                "Capacites", "CONTACT_TITLE", "CONTACT_EMAIL", "CONTACT_PHONE", "CONTACT_FIRST_NAME", "CONTACT_LAST_NAME",
                "ContactFonction", "LINKEDIN", "TIKTOK", "CONTACT_FAX", "CONTACT_ADDRESS", "CONTACT_POSTAL_CODE",
                "CONTACT_CITY", "CONTACT_PROVINCE",
            ],
            enabledRequiredField: ["OFFER_NAME", "DESC_COURT_DE", "DESC_COURT_EN", "DESC_COURT_ES", "DESC_COURT_FR", "DESC_COURT_IT", "DESC_COURT_JA", "DESC_COURT_NL",
                "DESC_COURT_RU", "DESC_COURT_ZH", "DESC_LONG_DE", "DESC_LONG_EN", "DESC_LONG_ES", "DESC_LONG_FR", "DESC_LONG_IT", "DESC_LONG_JA", "DESC_LONG_NL",
                "DESC_LONG_RU", "DESC_LONG_ZH", "ModePaiement", "Langue", "DemarcheEcoResponsable", "TypologiePromoSitra", "DESC_TOURISME_DURABLE", "DESC_PORTRAIT",
                "DESC_2023_INNOVATION", "DESC_2024_INNOVATION", "OFFER_PROMOTIONS", "OPENING_HOURS", "IMAGE", "DESC_HAND_AUDITIF", "DESC_HAND_MENTAL", "DESC_HAND_MOTEUR",
                "DESC_HAND_VISUEL", "LabelTourismeHandicap", "AccessibilityCriteriaForPeopleWithReducedMobility", "AccessibilityCriteriaForHearingLoss", "AccessibilityCriteriaForMentalImpairment",
                "AccessibilityCriteriaForVisualImpairment", "DISABLED_RECEPTION", "NB_WHEELCHAIR_SIMULTANEOUSLY_AVAILABLE", "EMAIL", "PHONE", "ADDRESS", "ADDRESS3", "COMPLEMENT_ADDRESS", "CITY",
                "DESC_COVID19", "DispositionsCovid", "DESC_2025_INNOVATION", "DESC_2026_INNOVATION", "FREE_PHONE", "OFFER_NAME_EN", "DESC_2027_INNOVATION"
            ],
            templates: [],
            editor: ClassicEditor,
        }
    },
    methods: {
        ...mapMutations("createCmaj", ["setSelectedFields", "setCurrentStep"]),
        ...mapMutations("preview", ["setCategoryFields"]),
        updateTitle: _.debounce(function(value) {
            this.newTitle = value
        }, 200),
        updateHelpDescription: _.debounce(function(value) {
            this.helpDescription = value
        }, 200),
        updateSelectedFields(index, fields) {
            this.setSelectedFields([index, fields])

            this.checkedTabulations[index] = fields.length > 0

            this.$forceUpdate()
        },
        selectAllFields(tabulations) {
            tabulations.forEach(tabulation => {
                let fields = this.deepReduce(tabulation.children)

                fields = fields.filter(field => field.selected)
                this.updateSelectedFields(tabulation.id, fields)
            })
        },
        deepReduce(array) {
            return array.reduce((acc, val) => {
                let endValue = this.hasChildren(val) ? this.deepReduce(val.children, acc) : val

                return acc.concat(endValue)
            }, [])
        },
        hasChildren(node) {
            return (typeof node === "object")
              && (typeof node.children !== "undefined")
              && (node.children.length > 0)
        },
        hasFieldsInTabulation(tabulation) {
            return this.selectedFields[tabulation.id].length !== 0
        },
        isTabulationEnabled(tabulation) {
            let enabled = false

            Object.values(this.categories).forEach(category => {
                if (category !== undefined && category.name === tabulation.code) {
                    enabled = true
                }
            })

            return enabled
        },
        getFieldsArray() {
            let fieldsArray = Object.values(this.selectedFields)
            fieldsArray = [].concat.apply([], fieldsArray)

            return fieldsArray
        },
        sortNonTypeDependantTabulations() {
            let sorted = []
            let types = ["GENERAL", "ACCES_HANDICAPES", "COMMUNICATION", "PLATFORM", "LOCALISATION", "OPENING_HOURS", "TARIF",
                "ROOM_RENTING", "MEDIA", "COVID", "CONTACTS", "EXTRA"]

            types.forEach(type => {
                let exist = this.nonTypeDepenant.find(tabulation => tabulation.code === type)

                if (exist !== null && exist !== undefined) {
                    sorted.push(exist)
                }
            })

            this.nonTypeDepenant = sorted
        },
        hasFieldRequiredEnabled(field) {
            let code = field.code !== undefined ? field.code : null

            return code === null || this.enabledRequiredField.includes(code)
        },
        init() {
            this.typeDependant = this.tabulations.filter(tabulation => tabulation.is_type_dependant)
            this.nonTypeDepenant = this.tabulations.filter(tabulation => !tabulation.is_type_dependant)
            if (this.selectAll !== undefined) {
                this.selectAllFields(this.tabulations)
            }

            this.tabulations.forEach(tabulation => {
                this.$set(this.checkedTabulations, tabulation.id, this.hasFieldsInTabulation(tabulation))
            })

            this.uncheckNotDisplayedTabs()
            this.sortNonTypeDependantTabulations()

            this.$global.loading = false
        },
        uncheckNotDisplayedTabs() {
            this.typeDependant.forEach(tabulation => {
                if (!this.isTabulationEnabled(tabulation)) {
                    this.$set(this.checkedTabulations, tabulation.id, false)

                    this.updateSelectedFields(tabulation.id, [])
                }
            })
        },
        removeGoodReasonDescription() {
            let generalTab = this.tabulations.find(tab => tab.code === "GENERAL")

            if (generalTab !== undefined) {
                generalTab.children.forEach((child, index) => {
                    if (child.code === "DESC_GOOD_REASONS") {
                        generalTab.children.splice(index, 1)
                    }
                })
            }
        },
        removeQuebecLabelForNonQuebecUser() {
            let categoriesWithQuebecLabels = ["RESTAURATION", "PRODUCTEUR", "PATRIMOINE_CULTUREL",
                "HOTELLERIE_PLEIN_AIR", "HOTELLERIE", "HEBERGEMENT_LOCATIF", "HEBERGEMENT_COLLECTIF", "EQUIPEMENT",
                "COMMERCE_ET_SERVICE", "ACTIVITE"]

            this.tabulations.forEach(tab => {
                if (categoriesWithQuebecLabels.includes(tab.code)) {
                    tab.children.forEach((child, index) => {
                        if (child.code === "QuebecLabels") {
                            tab.children.splice(index, 1)
                        }
                    })
                }
            })
        },
        isAspectField(field) {
            return !!(this.aspect && aspectFields.includes(field.code))
        },
    },
    computed: {
        ...mapState("createCmaj", ["selectedFields", "currentStep", "emailsValid", "selectedFields", "txtIntro"]),
        ...mapState("account", ["account"]),
        aspectIcone() {
            if (this.aspect !== undefined && this.aspect !== "") {
                return aspectElements.find(aspect => {
                    return aspect.name === this.aspect
                }).icon
            }
        },
    },
    beforeDestroy() {
        this.$global.$off("reload-info")
    },
    created() {
        this.init()

        this.$global.$on("reload-info", () => {
            this.init()
        })

        // Le champs 3 bonnes raisons de nous choisir n'est dispo que sur Tourinsoft
        if (this.account.tis_type.code === "APIDAE") {
            this.removeGoodReasonDescription()
        }

        //cacher les champs labels spécifiques au Quebec
        if (this.account.tis_type.code !== "DAHUB_QUEBEC") {
            this.removeQuebecLabelForNonQuebecUser()
        }
    },
}
</script>